import store from 'store/index';

const OAUTH_BASED_CHANNELS = new Set([
  'yandex', 'google', 'facebook', 'vkontakte', 'youtube', 'yandexmarket', 'yandexdisplay', 'targetmail',
  'googledbm', 'googledcm', 'yandexaudience', 'twitter', 'tiktok', 'vkads'
]);
const TOKEN_BASED_CHANNELS = new Set(['rbmail', 'ozon']);
const ONLY_TOKEN_BASED_CHANNELS = new Set(['adfox', 'wildberries']);
const CREDENTIAL_BASED_CHANNELS = new Set(['begun', 'weborama', 'adriver']);
const CUSTOM_BASED_CHANNELS = new Set(['custom']);

// can bind only to MCC account
const NON_DIRECT_CHANNELS = new Set(['facebook', 'googledcm', 'google']);

// can bind only to USUAL account
const DIRECT_ONLY_CHANNELS = new Set(['custom']);


export default function fillChannelsWithConnectionMethod (channels) {

  // if current account is not provided
  const currentAccount = store.getters['accounts/currentAccount'] || {};

  return channels.map(channel => {
    const connectionMethods = new Set([]);
    const channelName = channel.name;

    const directCondition = !(DIRECT_ONLY_CHANNELS.has(channelName) && currentAccount.type === 'MCC');
    const nonDirectCondition = !(NON_DIRECT_CHANNELS.has(channelName) && currentAccount.type === 'USUAL');

    const canBindToCurrentAccount = directCondition && nonDirectCondition;

    if (OAUTH_BASED_CHANNELS.has(channelName)){
      connectionMethods.add('OAUTH');
    }
    if (TOKEN_BASED_CHANNELS.has(channelName)) {
      connectionMethods.add('TOKEN');
    }
    if (ONLY_TOKEN_BASED_CHANNELS.has(channelName)) {
      connectionMethods.add('ONLY_TOKEN');
    }
    if (CREDENTIAL_BASED_CHANNELS.has(channelName)) {
      connectionMethods.add('CREDENTIALS');
    }
    if (CUSTOM_BASED_CHANNELS.has(channelName)) {
      connectionMethods.add('CUSTOM');
    }

    return {
      ...channel,
      connection_methods: connectionMethods,
      can_bind_to_current: canBindToCurrentAccount,
      is_direct_only: DIRECT_ONLY_CHANNELS.has(channelName)
    };
  });
}
